import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import ItemList from './ItemList';

import {
  CompositionsInterface,
  PrescriptionItemInterface,
} from '../../../../interfaces/prescription';

import { toggleItem as toggle } from '../../../../store/prescription/actions';
import { AppState } from '../../../../store';
import { ItemInterface } from '../../Dispensation/Table/types';

interface StateProps {
  prescriptionItems: PrescriptionItemInterface[];
}

interface DispatchProps {
  toggleItem: Function;
}

type Props = StateProps & DispatchProps;

const ItemListContainer: React.FC<Props> = ({
  prescriptionItems,
  toggleItem,
}: Props) => {
  const [items, setItems] = useState<Array<ItemInterface>>([]);
  const itemsStatus = useSelector(
    (state: AppState) => state.prescription.itemsStatus,
  );

  const transformItems = (
    list: PrescriptionItemInterface[],
  ): {
    id: number;
    title: string;
    quantity: number;
    unit: string;
    description: string;
    checked: boolean;
    dispensedLabel: string;
    blockedLabel: string;
    compositions: CompositionsInterface;
    prescribedQuantity?: number;
    dispensedQuantity?: number;
    availableQuantity?: number;
  }[] => {
    return list.map((item) => {

      const statusInfo = itemsStatus?.find(
        (status) => status.item_id === item.id,
      );

      return {
        id: item.id,
        title: item.name,
        quantity: item.original_quantity,
        unit: item.unit,
        description: item.dosage,
        checked: item.checked,
        blockedLabel: item.blocked ? 'bloqueio temporário' : '',
        dispensedLabel: item.dispensed ? 'dispensado' : '',
        compositions: item.compositions,
        recipe: item.recipe,
        cid: item.cid,
        prescribedQuantity: statusInfo?.prescribed_quantity,
        dispensedQuantity: statusInfo?.dispensed_quantity,
        availableQuantity: statusInfo?.available_quantity,
        isPartialDispensationEnabled: item.isPartialDispensationEnabled,
      };
    });
  };

  useEffect(() => {
    setItems(transformItems(prescriptionItems));
  }, [prescriptionItems, itemsStatus]);

  const onClickItem = (clicked: ItemInterface): void => {
    const toggleParams = { itemId: clicked.id, selectedQuantity: 'all' };
    setItems(transformItems(toggleItem(toggleParams)));
  };

  return <ItemList items={items} onClickItem={onClickItem} />;
};

const mapStateToProps = ({ prescription }: AppState): StateProps => ({
  prescriptionItems: prescription.prescription.items,
});

const mapDispatchToProps = {
  toggleItem: toggle,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemListContainer);
